import { useQuery } from '@tanstack/react-query';
import { getAccountActiveSearchForCaseResults } from 'services/ClaimscoreApiService/Accounts/Accounts.service';
import type { AccountActiveSearchResultsResponse } from 'services/ClaimscoreApiService/Accounts/types';

const QUERY_KEY = 'getAccountActiveSearchForCaseResults';

export type UseGetAccountActiveSearchForCaseResults = {
  caseId: string;
  searchValue: string;
};

export const useGetAccountActiveSearchForCaseResults = ({
  caseId,
  searchValue,
}: UseGetAccountActiveSearchForCaseResults) =>
  useQuery<AccountActiveSearchResultsResponse[], Error>({
    queryKey: [QUERY_KEY, caseId, searchValue],
    queryFn: () => getAccountActiveSearchForCaseResults(caseId, searchValue),
    enabled: Boolean(caseId),
  });
